import axios from 'axios';

// 根据环境设置 baseURL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production') {
    // 生产环境
    return 'https://www.48.club';
  }
  // 开发环境
  return '/';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000, // 可选：超时时间
})

axios.defaults.withCredentials = true

export const getTradeRace = async(params: any) => {
  return api.get(`https://api.trade-race.48.club`, { params, method: 'GET' })
}
export const getTradeRaceAirdrop = async(params: any) => {
  return api.get(`https://api.trade-race.48.club/airdrop`, { params, method: 'GET' })
}
export const getSoulRanking = async(params: any) => {
  return api.get(`https://soul-api.48.club/`, { params, method: 'GET' })
}
export const getSoulLevels = async() => {
  return api.get(`https://soul-api.48.club/levels`)
}
export default api